// import React, { useEffect, useState } from "react";

// function Card(props){
//     return(
//         <div className="profile">
//             <img src={props.image} width="100px" className="img1" />
//             <div className="detail">
//                 <h3>{props.username}</h3>
//                 <a href={props.link}>Profile Link</a>
//             </div>
//         </div>
//     );
// }

// function Card2(props){
//     return(
//         <div className="profile2">
//             <img src={props.image} width="150px" className="img2" />
//             <div className="detail2">
//                 <h3>{props.username}</h3>
//                 <h2>{props.name}</h2>
//                 <a href={props.link}>Profile Link</a>
//                 <div className="follow">x
//                     <p>Followers : {props.followers} </p>
//                     <p>Following : {props.following} </p>
//                     <p>Repos : {props.public_repos} </p>
//                 </div>
//                 <div className="repos">
//                     {props.repos.map((repo)=>{
//                         return <a key={repo.id} href={repo.html_url}>{repo.name}</a>
//                     })}
//                 </div>
                
//             </div>
//         </div>
//     );
// }

// function Body(){
//     const [profile, setprofile] = useState([]);
//     const [name, setname] = useState(null); 
//     const [username, setusername] = useState("");
//     const [repo,setrepo]=useState([]);

//     async function generatecard() {
//         const response = await fetch("https://api.github.com/users?per_page=20");
//         const data = await response.json();
//         setprofile(data);
//         setname(null); 
//     }

//     async function reposs(name) {
//         const response = await fetch(`https://api.github.com/users/${name}/repos`);
//         const data = await response.json();
//         setrepo(data);

//     }

//     async function searchprofile(name) {
//         if (!name) return;
//         const response = await fetch(`https://api.github.com/users/${name}`);         
//         if (response.ok) {
//             const data = await response.json();
//             setname(data); 
//             reposs(name);
//         } else {
//             setname(null);
//             setrepo([]); 
//             alert("User not found");
//         }
//     }

//     useEffect(() => {
//         generatecard();
//     }, []);

//     return(
//         <div className="body">
//             <div className="search">
//                 <input type="text" placeholder="search username" value={username} onChange={(e) => {setusername(e.target.value)}}/>
//                 <button onClick={() => searchprofile(username)}>Search</button>
//             </div>
//             <div className="allcard">
//                 {
//                     name ? (<Card2 key={name.id} image={name.avatar_url} username={name.login} name={name.name} followers={name.followers} following={name.following} public_repos={name.public_repos} repos={repo} link={name.html_url}/>) 
//                     : (profile.map((value) => <Card key={value.id} image={value.avatar_url} username={value.login} link={value.html_url} />))
//                 }
//             </div>
//         </div>
//     );
// }

// export default Body;














import React, { useEffect, useState } from "react";

function Card(props){
    return(
        <div className="profile">
            <img src={props.image} width="100px" className="img1" />
            <div className="detail">
                <h3>{props.username}</h3>
                <a href={props.link}>Profile Link</a>
            </div>
        </div>
    );
}

function Card2(props){
    return(
        <div className="profile2">
            <img src={props.image} width="150px" className="img2" />
            <div className="detail2">
                <h3>{props.username}</h3>
                <h2>{props.name}</h2>
                <a href={props.link}>Profile Link</a>
                <div className="follow">
                    <p>Followers : {props.followers} </p>
                    <p>Following : {props.following} </p>
                    <p>Repos : {props.public_repos} </p>
                </div>
                <div className="repos">
                    {props.repoo.map((repo)=>{
                        return <a key={repo.id} href={repo.html_url}>{repo.name}</a>
                    })}
                </div>
                
            </div>
        </div>
    );
}

function Body(){
    const [profile, setprofile] = useState([]);
    const [name, setname] = useState(null); 
    const [username, setusername] = useState("");
    const [repo,setrepo]=useState([]);

    async function generatecard() {
        const response = await fetch("https://api.github.com/users?per_page=20");
        const data = await response.json();
        setprofile(data);
        setname(null); 
    }

    async function searchprofile(name) {
        if (!name) return;
        const response = await fetch(`https://api.github.com/users/${name}`);         
        if (response.ok) {
            const data = await response.json();
            setname(data); 

            const repos = await fetch(data.repos_url);
            const repodata = await repos.json();
            setrepo(repodata);
        } 
        else {
            setname(null);
            setrepo([]); 
            alert("User not found");
        }
    }

    useEffect(() => {
        generatecard();
    }, []);

    return(
        <div className="body">
            <div className="search">
                <input type="text" placeholder="search username" value={username} onChange={(e) => {setusername(e.target.value)}}/>
                <button onClick={() => searchprofile(username)}>Search</button>
            </div>
            <div className="allcard">
                {
                    name ? (<Card2 key={name.id} image={name.avatar_url} username={name.login} name={name.name} followers={name.followers} following={name.following} public_repos={name.public_repos} repoo={repo} link={name.html_url}/>) 
                    : (profile.map((value) => <Card key={value.id} image={value.avatar_url} username={value.login} link={value.html_url} />))
                }
            </div>
        </div>
    );
}

export default Body;

